export const colorMap = {
    // Basic French (Canonical)
    'blanc': 'white',
    'beige': '#F5F5DC', // Ecru/Cream merged here
    'jaune': 'yellow', // Mustard/Gold merged here
    'orange': 'orange', // Corail/Salmon merged here
    'rouge': 'red', // Bordeaux/Burgundy merged here
    'rose': 'pink', // Fuchsia merged here
    'violet': 'purple', // Lilas merged here
    'bleu': 'blue', // Marine/Ciel/Turquoise merged here
    'vert': 'green', // Kaki/Olive merged here
    'marron': 'brown', // Camel/Tan merged here
    'gris': 'gray', // Anthracite/Silver merged here
    'noir': 'black',
    'multicolore': 'linear-gradient(45deg, red, yellow, green, blue)',
};

// Helper to safely get color string from product data
export const getColorName = (c) => {
    if (!c) return null;
    return typeof c === 'object' ? c.color : c;
};

export const getCssColor = (colorName) => {
    if (!colorName) return '#ccc';
    const lower = colorName.toLowerCase();

    // Check normalized version first
    const normalized = normalizeColor(lower);
    if (normalized && colorMap[normalized]) return colorMap[normalized];

    // Fallback to name if it might be a standard color
    return lower;
};

// Normalize color name to a standard key (e.g., "Bleu Ciel" -> "bleu" if mapped, or keep as is)
export const normalizeColor = (colorName) => {
    if (!colorName) return null;
    const lower = colorName.toLowerCase();

    // 1. Direct mapping check
    if (colorMap[lower]) return lower;

    // 2. Specific contained word entries (priority)
    // 2. Specific contained word entries (priority)
    // FORCE MAPPING TO MAIN COLORS to avoid splitting (e.g. "Navy" -> "marine" vs "Marine" -> "bleu")
    const specificMappings = [
        { term: 'wine', map: 'rouge' }, // was bordeaux
        { term: 'burgundy', map: 'rouge' },
        { term: 'navy', map: 'bleu' }, // was marine
        { term: 'marine', map: 'bleu' },
        { term: 'camo', map: 'multicolore' }, // was camo
        { term: 'snow', map: 'blanc' },
        { term: 'light blue', map: 'bleu' }, // was ciel
        { term: 'dark blue', map: 'bleu' }, // was marine
        { term: 'sky', map: 'bleu' },
        { term: 'off white', map: 'beige' }, // was écru
        { term: 'ecru', map: 'beige' },
        { term: 'charcoal', map: 'gris' }, // was anthracite
        { term: 'anthracite', map: 'gris' },
        { term: 'silver', map: 'gris' },
        { term: 'gold', map: 'jaune' },
    ];

    for (const { term, map } of specificMappings) {
        if (lower.includes(term)) return map;
    }

    // 3. General containment check against map keys
    // Sort keys by length desc to match "light blue" before "blue" if both existed (already handled above but good practice)
    for (const key of Object.keys(colorMap)) {
        if (lower.includes(key)) {
            return key;
        }
    }

    // 4. Main Category Mapping (Groups similar shades)
    // English -> French
    if (lower.includes('black') || lower.includes('noir')) return 'noir';
    if (lower.includes('white') || lower.includes('blanc') || lower.includes('snow')) return 'blanc';

    // Grey / Charcoal / Anthracite
    if (lower.includes('gray') || lower.includes('grey') || lower.includes('gris') || lower.includes('charcoal') || lower.includes('anthracite') || lower.includes('silver') || lower.includes('argent')) return 'gris';

    // Red / Burgundy / Wine
    if (lower.includes('red') || lower.includes('rouge') || lower.includes('bordeaux') || lower.includes('burgundy') || lower.includes('wine')) return 'rouge';

    // Blue / Navy / Sky / Indigo / Turquoise
    if (lower.includes('blue') || lower.includes('bleu') || lower.includes('navy') || lower.includes('marine') || lower.includes('ciel') || lower.includes('sky') || lower.includes('indigo') || lower.includes('turquoise') || lower.includes('canard')) return 'bleu';

    // Green / Olive / Khaki
    if (lower.includes('green') || lower.includes('vert') || lower.includes('kaki') || lower.includes('khaki') || lower.includes('olive') || lower.includes('sauge')) return 'vert';

    // Yellow / Mustard / Gold
    if (lower.includes('yellow') || lower.includes('jaune') || lower.includes('moutarde') || lower.includes('mustard') || lower.includes('gold') || lower.includes('or')) return 'jaune';

    // Orange / Coral / Salmon
    if (lower.includes('orange') || lower.includes('corail') || lower.includes('coral') || lower.includes('saumon') || lower.includes('salmon') || lower.includes('rouille')) return 'orange';

    // Purple / Lilac / Violet
    if (lower.includes('purple') || lower.includes('violet') || lower.includes('lilas') || lower.includes('lilac') || lower.includes('mauve') || lower.includes('plum')) return 'violet';

    // Pink / Rose / Fuchsia
    if (lower.includes('pink') || lower.includes('rose') || lower.includes('fuchsia')) return 'rose';

    // Brown / Camel / Tan
    if (lower.includes('brown') || lower.includes('marron') || lower.includes('camel') || lower.includes('tan') || lower.includes('cognac') || lower.includes('rust')) return 'marron';

    // Beige / Cream / Nude / Ecru
    if (lower.includes('beige') || lower.includes('cream') || lower.includes('crème') || lower.includes('nude') || lower.includes('off white') || lower.includes('ecru') || lower.includes('écru')) return 'beige';

    // Patterns
    if (lower.includes('multi') || lower.includes('camo') || lower.includes('imprimé')) return 'multicolore';

    return null;
};
